import { render, staticRenderFns } from "./InputFileSelector.vue?vue&type=template&id=f1339852"
import script from "./input-file-selector.js?vue&type=script&lang=js&external"
export * from "./input-file-selector.js?vue&type=script&lang=js&external"
import style0 from "./input-file-selector.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports